<template>
    <b-card header="Profile"
            header-bg-variant="info"
            header-text-variant="white"
    >
        <b-row>
            <b-col lg="6">
                <b-form-group label="First Name" label-for="firstname">
                    <b-form-input
                        id="firstname"
                        name="firstname"
                        type="text"
                        :value="form.firstname"
                        :disabled="readonly"
                    >
                    </b-form-input>
                    <input-help :form="form" field="firstname" text="Enter your first name."></input-help>
                </b-form-group>
                <b-form-group label="Last Name" label-for="lastname">
                    <b-form-input
                        id="lastname"
                        name="lastname"
                        type="text"
                        :value="form.lastname"
                        :disabled="readonly"
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="Email Address" label-for="email">
                    <b-form-input
                        id="email"
                        name="email"
                        type="email"
                        :value="form.email"
                        :disabled="readonly"
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

    </b-card>
</template>

<script>
import FormatsDates from '../mixins/FormatsDates';

export default {
    props: {
        'readonly': {
            type: Boolean,
            default: true,
        },
        'client': {},
        'user': {}
    },

    mixins: [FormatsDates],

    data() {
        return {
            form: new Form({
                firstname: this.user.firstname,
                lastname: this.user.lastname,
                email: this.user.email,
            })
        }
    },

    methods: {

    }
}
</script>
